<div style="display:flex;height: 100vh;justify-content: center;align-items: center;">
    <img src="../../assets/img/logo.png">
</div>